import React from 'react';
import styled from 'styled-components';
import NavTop from './navTop/NavTop';

const Wrapper = styled.div``;

function NavigationMobile({ setShowSearch }) {
  return (
    <Wrapper>
      <NavTop setShowSearch={setShowSearch} />
    </Wrapper>
  );
}

export default NavigationMobile;
